import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';

function ModalComponent({ open, setOpen, handleDelete, photo_title, album_title, id, title }) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    color: '#000',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open={open}>
      <Box sx={style}>
        {photo_title || album_title ? (
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Delete - {album_title ? album_title : photo_title}
          </Typography>
        ) : (
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Delete - {title}
          </Typography>
        )}
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Are you sure you want to delete {photo_title ? photo_title : album_title}?
        </Typography>
        <Stack spacing={2} direction="row" sx={{ justifyContent: 'center', padding: '30px' }}>
          <Button variant="text" color="success" sx={{ borderRadius: '100px', height: '70px', width: '70px' }}>
            <CheckIcon sx={{ fontSize: '38px' }} onClick={() => handleDelete(id)} />
          </Button>
          <Button variant="text" color="error" sx={{ borderRadius: '100px', height: '70px', width: '70px' }}>
            <CloseIcon sx={{ fontSize: '38px' }} onClick={() => setOpen(false)} />
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ModalComponent;
